import { SearchActions, SearchStore } from './types';

const initialState: SearchStore = {
  isLoadedSuggestions: false,
  isLoadingSuggestions: false,
  suggestionsError: null,
  suggestions: [],
  results: [],
  count: 0,
  offset: 0,
  topSearchedProductCategories: [],
  topSearchedProducts: [],
  searchString: '',
  filterData: {
    designers: [],
    locationTypes: [],
    productCategories: [],
  },
  filters: {
    designers: [],
    locationTypes: [],
    productCategories: [],
  },
};

const reducer = (state = initialState, action: { type: string; payload: any }) => {
  // Store actions
  const {
    FetchSearchDataSuccess,
    FetchSearchSuggestionsDataSuccess,
    FetchTopSearchedProductsSuccess,
    FetchTopSearchedProductCategoriesSuccess,
    FetchSearchDataBegin,
    FetchSearchFilterDataSuccess,
    FetchSearchSuggestionsDataBegin,
    FetchSearchSuggestionsDataError,
  } = SearchActions;

  switch (action.type) {
    case FetchSearchSuggestionsDataBegin: {
      return {
        ...state,
        isLoadedSuggestions: false,
        isLoadingSuggestions: true,
        suggestionsError: null,
      };
    }
    case FetchSearchSuggestionsDataSuccess: {
      return {
        ...state,
        isLoadedSuggestions: true,
        isLoadingSuggestions: false,
        suggestionsError: null,
        suggestions: action.payload.results,
      };
    }
    case FetchSearchSuggestionsDataError: {
      return {
        ...state,
        isLoadedSuggestions: true,
        isLoadingSuggestions: false,
        suggestionsError: action.payload,
      };
    }
    case FetchSearchDataBegin: {
      return {
        ...state,
        searchString: action.payload,
      };
    }
    case FetchSearchDataSuccess: {
      return {
        ...state,
        results: action.payload.offset
          ? [...state.results, ...action.payload.results]
          : action.payload.results,
        count: action.payload.count,
        offset: action.payload.offset,
        filters: action.payload.filters,
      };
    }
    case FetchTopSearchedProductsSuccess: {
      return {
        ...state,
        topSearchedProducts: action.payload,
      };
    }
    case FetchTopSearchedProductCategoriesSuccess: {
      return {
        ...state,
        topSearchedProductCategories: action.payload,
      };
    }
    case FetchSearchFilterDataSuccess: {
      return {
        ...state,
        filterData: action.payload,
      };
    }
    default:
      return state;
  }
};

export default reducer;
